import { styled } from 'styled-components';
import { IGlobaVariables } from '../../Layout/styles';

import { IPagination1, defaultParams } from './params';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IPagination1;
}>`
  .pagination {
    display: flex;
    justify-content: center;
    padding: 50px 0;

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      height: 40px;
      margin: 0 5px;
      padding: 0 5px;
      color: ${({ $config: styles }) => styles.color};
      background-color: ${({ $config: styles }) => styles.backgroundColor};
      border-radius: ${({ $config: styles }) => styles.borderRadius};
      border: ${({ $config: styles }) => styles.border};
      font-family: ${({ $config: styles }) => styles.fontFamily};
      font-weight: ${({ $config: styles }) => styles.fontWeight};
      font-size: ${({ $config: styles }) => styles.fontSize};
      line-height: ${({ $config: styles }) => styles.fontSize};
      font-style: ${({ $config: styles }) => styles.fontStyle};
      transition: all 0.3s ease-in-out;
      cursor: pointer;

      &.between {
        pointer-events: none;
      }

      &.active {
        pointer-events: none;
        color: ${({ $config: styles }) => styles.group_active.color};
        background-color: ${({ $config: styles }) => styles.group_active.backgroundColor};
        border: ${({ $config: styles }) => styles.group_active.border};
      }

      &:hover {
        color: ${({ $config: styles }) => styles.hover_color};
        background-color: ${({ $config: styles }) => styles.hover_backgroundColor};
        border: ${({ $config: styles }) => styles.hover_border};
        text-decoration: none;
      }
    }
  }
`;

export default Styles;
